<template>
  <div class="user-agreements">
    <h4>{{i18n[locale].notes_for}} {{activeSchoolYear.name}}</h4>
    <div v-if="userCanEditAgreementNote">
      <AppEIPWYZIWYG
        :textInput="agreements"
        @close="updateAgreements">
      </AppEIPWYZIWYG>
    </div>
    <div class="user-agreements__notes" v-else>
      <div v-html="agreements"></div>
      <p v-if="agreements.length < 1" class="text-explainer">Ingen noter</p>
    </div>
  </div>
</template>

<script>
  import AppEIPWYZIWYG from '../common/AppEIPWYZIWYG'
  import docendo from '../../docendo'

  export default {
    components: {AppEIPWYZIWYG},
    props: {
      userId: {
        type: Number,
        required: true
      },
      userAgreements: {
        default: '',
        required: false
      },
      isReadAgreements: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        agreements: '',
        locale: 'da',
        i18n: {
          da: {
            notes_for: 'Noter til'
          },
          nb: {
            notes_for: 'Noter til'
          },
          en: {
            notes_for: 'Notes for'
          }
        }
      }
    },
    computed: {
      activeSchoolYear () {
        return this.$store.state.localActivatedSchoolYear
      },
      userCanEditAgreementNote () {
        return this.userHasPermission('can_edit_user_year_notes')
      },
      user () {
        return this.$store.state.user
      },
      isPermissionsActivatedForSchool () {
        return this.$store.getters.isPermissionsActivatedForSchool
      },
      userPermissions () {
        return this.$store.getters.userPermissions
      }
    },
    watch: {
      activeSchoolYear () {
        this.readAgreements()
      },
      userAgreements (val) {
        this.agreements = val
      }
    },
    methods: {
      userHasPermission (val) {
        if (!this.user) {
          return false
        }
        if (this.isPermissionsActivatedForSchool) {
          return this.userPermissions.indexOf(val) > -1 || this.user.admin
        } else {
          return true
        }
      },
      readAgreements () {
        if (!this.isReadAgreements) {
          return
        }
        docendo.schoolUserYearRead(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, success => {
          this.agreements = success.agreements
        }, failure => {
          console.log('failed!')
        })
      },
      updateAgreements (updatedText) {
        docendo.schoolUserYearUpdate(window.SCHOOL.id, this.userId, this.activeSchoolYear.name, {'agreements': updatedText.text},
          success => {
            this.agreements = success.agreements
          }, failure => {
            console.log('failed!')
          })
      }
    },
    beforeMount () {
      this.locale = window.USER.language
    },
    mounted () {
      this.agreements = this.userAgreements
      this.readAgreements()
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .user-agreements {
    border: 1px solid #e2e8f0;
  }

  .user-agreements h4 {
    text-transform: uppercase;
    border-bottom: 1px solid #e2e8f0;
    padding: 4px;
  }

  .user-agreements__notes{
    padding: 0.5rem;
  }

  .user-agreements__notes .text-explainer {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// SubjectsDistributionUserAgreements.vue?0d2edc98